import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import history from 'util/history';
import PropTypes from 'prop-types';
import routes from './routes';
import BodyWrapper from './BodyWrapper';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'blueimp-canvas-to-blob';
import 'material-icons/iconfont/material-icons.scss';
import 'material-components-web/dist/material-components-web.min.css';
import 'static/css/index.css';
import 'static/css/tg.material.min.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {AuthProvider} from 'components/AuthProvider';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'
/* global document */


const theme = createTheme({
  /*
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1a1a1a',
          color: '#ffffff',
        },
      },
    },
  },
  */
  palette: {
    primary: {
      main: '#fff', /* colors: cyan500 */
    },
  },
});


React.PropTypes = PropTypes;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
})


ReactDOM.render((
  <BodyWrapper>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Router
              history={history}
              routes={routes}
            />
          </AuthProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </BodyWrapper>

), document.getElementById('app'));
